import { render, staticRenderFns } from "./m_chinese_Culture_Video_Exhibition_2026.vue?vue&type=template&id=c2817372&scoped=true"
import script from "./m_chinese_Culture_Video_Exhibition_2026.vue?vue&type=script&lang=js"
export * from "./m_chinese_Culture_Video_Exhibition_2026.vue?vue&type=script&lang=js"
import style0 from "./m_chinese_Culture_Video_Exhibition_2026.vue?vue&type=style&index=0&id=c2817372&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2817372",
  null
  
)

export default component.exports